import * as React from 'react'

const IconUser = (props) => {
  const { color } = props
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <defs>
        <path id='icon-user_svg__a' d='M0 0h30v22.357H0z' />
      </defs>
      <g fill='none' fillRule='evenodd'>
        <path
          d='M24 6.047c-5.236 0-9.497 4.199-9.497 9.358 0 5.16 4.261 9.359 9.497 9.359 5.237 0 9.497-4.199 9.497-9.36 0-5.158-4.26-9.357-9.497-9.357m0 20.764c-6.383 0-11.574-5.117-11.574-11.406C12.426 9.117 17.617 4 24 4s11.574 5.117 11.574 11.405c0 6.289-5.19 11.406-11.574 11.406'
          fill={color || '#fff'}
        />
        <g transform='translate(9 21.643)'>
          <mask id='icon-user_svg__b' fill='#fff'>
            <use xlinkHref='#icon-user_svg__a' />
          </mask>
          <path
            d='M15 22.357c-5.668 0-9.79-1.015-12.25-1.866C.817 19.823-.329 17.828.082 15.85.757 12.622 2.499 6.329 6.617.442A1.051 1.051 0 0 1 8.063.18c.472.321.591.96.266 1.424C4.418 7.193 2.76 13.186 2.12 16.26a1.985 1.985 0 0 0 1.32 2.299c2.307.798 6.186 1.751 11.56 1.751 5.377 0 9.256-.953 11.564-1.751a1.985 1.985 0 0 0 1.319-2.299c-.64-3.074-2.3-9.067-6.21-14.656A1.016 1.016 0 0 1 21.938.18a1.051 1.051 0 0 1 1.445.262c4.119 5.887 5.86 12.18 6.535 15.407.411 1.979-.736 3.974-2.668 4.642-2.459.851-6.582 1.866-12.25 1.866'
            fill={color || '#fff'}
            mask='url(#icon-user_svg__b)'
          />
        </g>
      </g>
    </svg>
  )
}

export default IconUser
